type Outcome = 'accepted' | 'dismissed';

export interface BeforeInstallPromptEvent extends Event {
  readonly platforms: string[];
  readonly userChoice: Promise<{
    outcome: Outcome;
    platform: string;
  }>;
  prompt(): Promise<void>;
}

let defferedPrompt: BeforeInstallPromptEvent | undefined;

export const canInstallPWA = () => !!defferedPrompt;
export const setDefferedPrompt = (e: BeforeInstallPromptEvent | undefined) =>
  (defferedPrompt = e);

export const setupPWAInstallPrompt = (window: Window) => {
  window.addEventListener('beforeinstallprompt', (e) => {
    setDefferedPrompt(e as BeforeInstallPromptEvent);
  });
};

export const triggerPWAInstall = async (
  callback: (outcome: Outcome) => void,
) => {
  if (defferedPrompt) {
    defferedPrompt.prompt();
    const { outcome } = await defferedPrompt.userChoice;

    callback(outcome);

    if (outcome === 'accepted') {
      setDefferedPrompt(undefined);
    }
  }
};
